export default __webpack_public_path__ + "static/media/whyVisit2.0fe4d2fd.svg";